// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopupFooter__container-c6bff4 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  height: 72px;
  width: 100%;
  background-color: var(--base-10);
  padding: 0 25px;
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/PopupFooter/PopupFooter.style.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,gCAAA;EACA,eAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-shrink: 0;\n  height: 72px;\n  width: 100%;\n  background-color: var(--base-10);\n  padding: 0 25px;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PopupFooter__container-c6bff4`
};
module.exports = ___CSS_LOADER_EXPORT___;
